var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0001,
    height: 24.0006,
    rx: 12.0001,
    fill: "#96989A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0266 5C9.98166 5 8.65243 5.84355 7.60438 7.35172C7.42544 7.60734 7.47657 7.99077 7.75775 8.1697L8.85692 9.01325C9.11254 9.21775 9.49598 9.16663 9.70047 8.91101C10.3395 8.11858 10.8252 7.65846 11.8221 7.65846C12.6146 7.65846 13.5859 8.14414 13.5859 8.91101C13.5859 9.49894 13.1002 9.78012 12.3334 10.2147C11.4131 10.7259 10.2117 11.365 10.2117 12.9498V13.1799C10.2117 13.5378 10.4929 13.7934 10.8252 13.7934H12.6912C13.0236 13.7934 13.3047 13.5378 13.3047 13.1799V13.0521C13.3047 11.9529 16.5 11.9018 16.5 8.93657C16.5 6.71266 14.1738 5 12.0266 5ZM11.771 14.5602C10.7741 14.5602 9.98166 15.3527 9.98166 16.324C9.98166 17.2954 10.7741 18.0878 11.771 18.0878C12.7424 18.0878 13.5348 17.2954 13.5348 16.324C13.5348 15.3527 12.7424 14.5602 11.771 14.5602Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPlaceholder);
export default __webpack_public_path__ + "static/media/tokenPlaceholder.b6ebe60fa4e2e9cfab120f8b023e4506.svg";
export { ForwardRef as ReactComponent };